import { TeamHomeAwayImageCombinedProps } from './types';

const usePresenter = (props: TeamHomeAwayImageCombinedProps): TeamHomeAwayImageCombinedProps => {
  return props;
};

export default usePresenter;
